// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Inter.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

@font-face {
    font-family: "Inter";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("ttf");
}

h1,
h3,
p,
body {
    margin: 0;
}

a {
    text-decoration: none;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 500;
}

a:hover {
    color: #FFFFFF;
    text-decoration: underline;
}

.default {
    background-image: linear-gradient(135deg, #3B5E8F, #5F84BC, #8FB6E8);
}

.clouds {
    background-image: linear-gradient(135deg, #4F6F9C, #6F8FB6, #9FB6D4);
}

.mist {
    background-image: linear-gradient(135deg, #6F7F97, #8C9CB1, #B2BECF);
}

.rain {
    background-image: linear-gradient(135deg, #3E5878, #567497, #7F9BB8);
}

.drizzle {
    background-image: linear-gradient(135deg, #4A678F, #6C8FB6, #9AB4D3);
}

.snow {
    background-image: linear-gradient(135deg, #B7CBE0, #94B2D3, #6F8FB8);
}

.thunderstorm {
    background-image: linear-gradient(135deg, #2E3F56, #415973, #5F7792);
}

.night {
    background-image: linear-gradient(135deg, #1C2740, #2B3F66, #445A86);
}

nav {
    height: 64px;
    width: 100%;
    color: #F8FAFC;
    padding: 24px;

    display: flex;
    justify-content: space-between;
    align-items: center;
}

body {
    min-height: 100vh;
    font-family: "Inter";

    display: flex;
    flex-direction: column;
}

main {
    width: 100%;
    height: 100%;
    padding: 24px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

footer {
    margin-top: auto;

    padding: 24px 0;

    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.3px;
    color: rgba(255, 255, 255, 0.65);
}

.full-attribution {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 12px;
}

.navbar-title {
    font-size: 28px;
    letter-spacing: 0.5px;
    font-weight: 500;
}

input[type="search"] {
    height: 36px;
    width: 270px;
    padding: 0 12px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.345);
    color: #F8FAFC;
    font-size: 15px;
    font-weight: 400;
}

input[type="search"]:focus {
    outline: none;
    border: 1px solid rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.15);
}

label {
    font-size: 18px;
    font-weight: 500;
    color: #F1F5F9;
    opacity: 0.95;
    letter-spacing: 0.3px;
}

.search-bar-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.list {
    width: 270px;
    padding: 6px 0;
    background-color: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.45);
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.city-info-dropdown-item {
    padding: 0 14px;
    font-size: 16px;
    font-weight: 400;
    color: #F8FAFC;
    cursor: pointer;
    line-height: 1.4;
    height: 40px;

    display: flex;
    align-items: center;
}

.city-info-dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.25);
}

.city-name-span {
    font-weight: 500;
}

.country-name- {
    font-weight: 400;
}

.weather-result-wrapper {
    margin-top: 12px;
    width: 340px;

    padding: 24px;

    border-radius: 16px;

    background-color: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.35);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.weather-result-location {
    font-size: 22px;
    color: #F8FAFC;

    letter-spacing: 0.2px;
}

.weather-result-temperature {
    display: flex;
    align-items: center;
    gap: 16px;

    font-size: 56px;
    color: #F8FAFC;
    line-height: 1;
}

.weather-result-description {
    font-size: 16px;
    text-transform: capitalize;
    color: rgba(248, 250, 252, 0.9);

    font-weight: 400;
}

.weather-result-min-max-temp {
    display: flex;
    gap: 16px;

    font-size: 14px;
    color: rgba(248, 250, 252, 0.75);
    font-weight: 400;
}

.weather-result-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    margin-top: 8px;
}

.weather-result-details-label {
    font-size: 12px;
    font-weight: 500;
    color: rgba(248, 250, 252, 0.65);
}

.weather-result-details-value {
    font-size: 16px;
    font-weight: 500;
    color: #F8FAFC;
}

.btns-wrapper {
    display: flex;
    gap: 2px;
    padding: 2px;

    border-radius: 8px;

    background-color: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.35);

    margin-top: 40px;
}

.toggle-btn {
    border: none;
    height: 26px;
    border-radius: 6px;
    padding: 0 8px;

    font-size: 13px;
    font-weight: 500;
    color: rgba(248, 250, 252, 0.85);
    cursor: pointer;
    background-color: transparent;
}

.selected-btn {
    background-color: rgba(255, 255, 255, 0.35);
    color: #F8FAFC;
}

.weather-result img {
    width: 48px;
    height: 48px;
}

.weather-forecast {
    margin-top: 32px;
}

.weather-forecast-wrapper {
    display: flex;
    gap: 14px;
}

.weather-forecast-wrapper img {
    width: 36px;
    height: 36px;
}

.forecast-day-wrapper {
    padding: 14px;
    border-radius: 14px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    background-color: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.25);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);

    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.forecast-day-wrapper:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.35);
}

.day-of-week-label {
    font-size: 13px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
    letter-spacing: 0.3px;
}

.temp-forecast {
    font-size: 20px;
    font-weight: 600;
    color: #FFFFFF;
}

.pop-forecast {
    font-size: 13px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.75);
}

.inactive {
    display: none;
}

@media (max-width: 430px) {
    .weather-forecast {
        max-width: 350px;
    }

    .weather-forecast-wrapper {
        overflow-x: auto;
        scroll-behavior: smooth;

        padding: 12px;

        border-radius: 14px;
        mask-image: linear-gradient(to right,
                transparent,
                black 16px,
                black calc(100% - 16px),
                transparent);
    }

    .forecast-day-wrapper{
        box-shadow: none;
    }

    footer {
        max-width: 350px;
        align-self: center;
    }

    .full-attribution{
        align-items: center;
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,0DAA2C;AAC/C;;AAEA;;;;IAII,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,aAAa;;IAEb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;;IAEpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;;IAEb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;;IAEhB,eAAe;;IAEf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,2CAA2C;IAC3C,4CAA4C;IAC5C,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,2CAA2C;IAC3C,2CAA2C;IAC3C,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;;IAEZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;;IAEZ,aAAa;;IAEb,mBAAmB;;IAEnB,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;;IAE3C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;;IAEd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,+BAA+B;;IAE/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;;IAET,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;;IAEZ,kBAAkB;;IAElB,2CAA2C;IAC3C,2CAA2C;;IAE3C,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,cAAc;;IAEd,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,2CAA2C;IAC3C,2CAA2C;IAC3C,0CAA0C;;IAE1C,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;;QAEvB,aAAa;;QAEb,mBAAmB;QACnB;;;;4BAIoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n@font-face {\n    font-family: \"Inter\";\n    src: url(\"./fonts/Inter.ttf\") format(\"ttf\");\n}\n\nh1,\nh3,\np,\nbody {\n    margin: 0;\n}\n\na {\n    text-decoration: none;\n    color: rgba(255, 255, 255, 0.85);\n    font-weight: 500;\n}\n\na:hover {\n    color: #FFFFFF;\n    text-decoration: underline;\n}\n\n.default {\n    background-image: linear-gradient(135deg, #3B5E8F, #5F84BC, #8FB6E8);\n}\n\n.clouds {\n    background-image: linear-gradient(135deg, #4F6F9C, #6F8FB6, #9FB6D4);\n}\n\n.mist {\n    background-image: linear-gradient(135deg, #6F7F97, #8C9CB1, #B2BECF);\n}\n\n.rain {\n    background-image: linear-gradient(135deg, #3E5878, #567497, #7F9BB8);\n}\n\n.drizzle {\n    background-image: linear-gradient(135deg, #4A678F, #6C8FB6, #9AB4D3);\n}\n\n.snow {\n    background-image: linear-gradient(135deg, #B7CBE0, #94B2D3, #6F8FB8);\n}\n\n.thunderstorm {\n    background-image: linear-gradient(135deg, #2E3F56, #415973, #5F7792);\n}\n\n.night {\n    background-image: linear-gradient(135deg, #1C2740, #2B3F66, #445A86);\n}\n\nnav {\n    height: 64px;\n    width: 100%;\n    color: #F8FAFC;\n    padding: 24px;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\nbody {\n    min-height: 100vh;\n    font-family: \"Inter\";\n\n    display: flex;\n    flex-direction: column;\n}\n\nmain {\n    width: 100%;\n    height: 100%;\n    padding: 24px;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\nfooter {\n    margin-top: auto;\n\n    padding: 24px 0;\n\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    color: rgba(255, 255, 255, 0.65);\n}\n\n.full-attribution {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    gap: 12px;\n}\n\n.navbar-title {\n    font-size: 28px;\n    letter-spacing: 0.5px;\n    font-weight: 500;\n}\n\ninput[type=\"search\"] {\n    height: 36px;\n    width: 270px;\n    padding: 0 12px;\n    border-radius: 10px;\n    background-color: rgba(255, 255, 255, 0.12);\n    border: 1px solid rgba(255, 255, 255, 0.345);\n    color: #F8FAFC;\n    font-size: 15px;\n    font-weight: 400;\n}\n\ninput[type=\"search\"]:focus {\n    outline: none;\n    border: 1px solid rgba(255, 255, 255, 0.6);\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.15);\n}\n\nlabel {\n    font-size: 18px;\n    font-weight: 500;\n    color: #F1F5F9;\n    opacity: 0.95;\n    letter-spacing: 0.3px;\n}\n\n.search-bar-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.list {\n    width: 270px;\n    padding: 6px 0;\n    background-color: rgba(255, 255, 255, 0.14);\n    border: 1px solid rgba(255, 255, 255, 0.45);\n    border-radius: 10px;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n}\n\n.city-info-dropdown-item {\n    padding: 0 14px;\n    font-size: 16px;\n    font-weight: 400;\n    color: #F8FAFC;\n    cursor: pointer;\n    line-height: 1.4;\n    height: 40px;\n\n    display: flex;\n    align-items: center;\n}\n\n.city-info-dropdown-item:hover {\n    background-color: rgba(255, 255, 255, 0.25);\n}\n\n.city-name-span {\n    font-weight: 500;\n}\n\n.country-name- {\n    font-weight: 400;\n}\n\n.weather-result-wrapper {\n    margin-top: 12px;\n    width: 340px;\n\n    padding: 24px;\n\n    border-radius: 16px;\n\n    background-color: rgba(255, 255, 255, 0.16);\n    border: 1px solid rgba(255, 255, 255, 0.35);\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n}\n\n.weather-result-location {\n    font-size: 22px;\n    color: #F8FAFC;\n\n    letter-spacing: 0.2px;\n}\n\n.weather-result-temperature {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    font-size: 56px;\n    color: #F8FAFC;\n    line-height: 1;\n}\n\n.weather-result-description {\n    font-size: 16px;\n    text-transform: capitalize;\n    color: rgba(248, 250, 252, 0.9);\n\n    font-weight: 400;\n}\n\n.weather-result-min-max-temp {\n    display: flex;\n    gap: 16px;\n\n    font-size: 14px;\n    color: rgba(248, 250, 252, 0.75);\n    font-weight: 400;\n}\n\n.weather-result-details {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 12px;\n    margin-top: 8px;\n}\n\n.weather-result-details-label {\n    font-size: 12px;\n    font-weight: 500;\n    color: rgba(248, 250, 252, 0.65);\n}\n\n.weather-result-details-value {\n    font-size: 16px;\n    font-weight: 500;\n    color: #F8FAFC;\n}\n\n.btns-wrapper {\n    display: flex;\n    gap: 2px;\n    padding: 2px;\n\n    border-radius: 8px;\n\n    background-color: rgba(255, 255, 255, 0.18);\n    border: 1px solid rgba(255, 255, 255, 0.35);\n\n    margin-top: 40px;\n}\n\n.toggle-btn {\n    border: none;\n    height: 26px;\n    border-radius: 6px;\n    padding: 0 8px;\n\n    font-size: 13px;\n    font-weight: 500;\n    color: rgba(248, 250, 252, 0.85);\n    cursor: pointer;\n    background-color: transparent;\n}\n\n.selected-btn {\n    background-color: rgba(255, 255, 255, 0.35);\n    color: #F8FAFC;\n}\n\n.weather-result img {\n    width: 48px;\n    height: 48px;\n}\n\n.weather-forecast {\n    margin-top: 32px;\n}\n\n.weather-forecast-wrapper {\n    display: flex;\n    gap: 14px;\n}\n\n.weather-forecast-wrapper img {\n    width: 36px;\n    height: 36px;\n}\n\n.forecast-day-wrapper {\n    padding: 14px;\n    border-radius: 14px;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    background-color: rgba(255, 255, 255, 0.12);\n    border: 1px solid rgba(255, 255, 255, 0.25);\n    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);\n\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.forecast-day-wrapper:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.35);\n}\n\n.day-of-week-label {\n    font-size: 13px;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.85);\n    letter-spacing: 0.3px;\n}\n\n.temp-forecast {\n    font-size: 20px;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.pop-forecast {\n    font-size: 13px;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.inactive {\n    display: none;\n}\n\n@media (max-width: 430px) {\n    .weather-forecast {\n        max-width: 350px;\n    }\n\n    .weather-forecast-wrapper {\n        overflow-x: auto;\n        scroll-behavior: smooth;\n\n        padding: 12px;\n\n        border-radius: 14px;\n        mask-image: linear-gradient(to right,\n                transparent,\n                black 16px,\n                black calc(100% - 16px),\n                transparent);\n    }\n\n    .forecast-day-wrapper{\n        box-shadow: none;\n    }\n\n    footer {\n        max-width: 350px;\n        align-self: center;\n    }\n\n    .full-attribution{\n        align-items: center;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
